export const APP_NAME = 'Exam Copilot';
// NOTE: on garde l'ancien préfixe pour ne pas effacer les données locales
// (progression, thème, auth) des utilisateurs existants.
export const STORAGE_PREFIX = 'certexam';
